module.exports = __webpack_public_path__ + "img/logo-icrea-footer.84f73b0d.svg";